import { makeStyles } from '@material-ui/styles'

export const productParameterExpansionStyles = makeStyles((theme: any) => ({
    root: {
        '@media screen and (-webkit-min-device-pixel-ratio:0)': {
            display: 'contents'
        },

        '& .ProductParameterExpansionDesignOwn-recommendedParameters': {
            marginRight: theme.spacing(1)
        },
        '& .ProductParameterExpansionDesignLater-container': {
            padding: '32px',

            '&__link': {
                margin: '0 auto',
                paddingTop: '8px',
                boxShadow: 'rgba(0, 0, 0, 0.12) 4px 4px 4px'
            },
            '&__pdf': {
                fontSize: '56px'
            }
        }
    },
    modal: {
        '& .MuiButton-root': {

            borderRadius: 0,
            '& .MuiSvgIcon-root': {
                display: 'block',
                margin: 0
            },
            '&.MuiButton-containedPrimary:hover': {
                color: theme.palette.primary.contrastText
            }
        },
        '& .ProductParameterExpansion-designLibraryGallery': {
            perspective: '240px',
            position: 'relative',
            '&Container': {
                backgroundColor: theme.palette.background.paper,
                maxWidth: '980px',
                padding: theme.spacing(8, 4)
            },
            '&CloseButton': {
                alignSelf: 'flex-end',
                marginTop: '-48px',
                marginRight: '-16px'
            },
            '&ArrowButton': {
                minWidth: 0,
                paddingLeft: theme.spacing(.75),
                paddingRight: theme.spacing(.75)
            },
            '& .item': {
                position: 'absolute',
                transition: 'all .5s',
                backgroundColor: theme.palette.background.paper,
                border: 'solid 2px black',
                cursor: 'pointer'
            },
            '& .item.hidden': {
                display: 'none'
            },
            '& .item.prev2': {
                'z-index': -2,
                order: 1,
                left: 0,
                opacity: .4
            },
            '& .item.prev1': {
                'z-index': -1,
                order: 2,
                left: 0
            },
            '& .item.current': {
                'z-index': 0,
                order: 3,
                left: 0
            },
            '& .item.next1': {
                'z-index': -1,
                order: 4,
                left: 0
            },
            '& .item.next2': {
                'z-index': -2,
                order: 5,
                left: 0,
                opacity: .4
            }
        }
    }
}), { name: 'ProductParameterExpansion' })
